import React from 'react';
import { useIntl } from 'react-intl';

import { useFormattedPrice, useLoyaltyBannerType } from '@hooks';
import { ELoyaltyBannerType } from '@model';
import { featuresMessages } from '@services/localizationService';
import { CartLayout } from '@sharedComponents/Layout';
import { GridDivider } from '@sharedComponents/Separators';
import { b } from '@styles/generalStyles';
import { ReactFCV } from '@types';
import { DIVIDER_COLOR, DIVIDER_HEIGHT } from '@utils/constants';

import { useCartPageContext } from '../../../context';

import { BodyColumn } from './componentsHelpers';
import { SLoyaltyBannerWrapper } from './styled';

export const LoyaltyBannerWrapper: ReactFCV = () => {
  const {
    state: { pricesSummary },
  } = useCartPageContext();

  const { formatMessage } = useIntl();
  const calculatedPoints = pricesSummary.priceProductsSummary - pricesSummary.discountWithoutDelivery;
  const { price: formattedPoints } = useFormattedPrice(calculatedPoints);

  const loyaltyType = useLoyaltyBannerType();
  if (loyaltyType === ELoyaltyBannerType.DISABLED) {
    return null;
  }

  const text =
    loyaltyType === ELoyaltyBannerType.ALLOWED
      ? featuresMessages.loyaltyEarnByPurchase
      : featuresMessages.loyaltyEnrollInto;

  return (
    <SLoyaltyBannerWrapper data-testid="loyalty-banner-wrapper">
      <GridDivider color={DIVIDER_COLOR} height={DIVIDER_HEIGHT} />
      <CartLayout
        serviceActive={true}
        serviceDisabled={false}
        bodyColumn={BodyColumn(formatMessage(text, { b, points: formattedPoints }))}
      />
    </SLoyaltyBannerWrapper>
  );
};
